import { ObjectSerializer } from "../DiscoveryEngine.TS/Serialization/ObjectSerializer";

export class UpdateResultDto implements ObjectSerializer {

	public Guid: string;
	public Created: string;
	public Modified: string;
	public Subject: string;
	public UserGuid: string;
	public ScopeGuid: string;
	public SourceUserGuid: string;
	public SourceUserName: string;
	public TargetUserGuid: string;
	public TargetUserName: string;
	public TargetGroupGuid: string;
	public TargetGroupName: string;
	public ServerGuid: string;
	public TenantGuid: string;

	constructor() {
		this.Guid = "";
		this.Created = "";
		this.Modified = "";
		this.Subject = "";
		this.UserGuid = "";
		this.ScopeGuid = "";
		this.SourceUserGuid = "";
		this.SourceUserName = "";
		this.TargetUserGuid = "";
		this.TargetUserName = "";
		this.TargetGroupGuid = "";
		this.TargetGroupName = "";
		this.ServerGuid = "";
		this.TenantGuid = "";
	}

	public Write(obj: any, context: any): void {
		obj.update_result = {};
		obj = obj.update_result;

		if (this.Guid)
			obj.guid = this.Guid;

		if (this.Created)
			obj.created = this.Created;

		if (this.Modified)
			obj.modified = this.Modified;

		if (this.Subject)
			obj.subject = this.Subject;

		if (this.UserGuid)
			obj.user_guid = this.UserGuid;

		if (this.ScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.SourceUserGuid)
			obj.source_user_guid = this.SourceUserGuid;

		if (this.SourceUserName)
			obj.source_user_name = this.SourceUserName;

		if (this.TargetUserGuid)
			obj.target_user_guid = this.TargetUserGuid;

		if (this.TargetUserName)
			obj.target_user_name = this.TargetUserName;

		if (this.TargetGroupGuid)
			obj.target_group_guid = this.TargetGroupGuid;

		if (this.TargetGroupName)
			obj.target_group_name = this.TargetGroupName;

		if (this.ServerGuid)
			obj.server_guid = this.ServerGuid;

		if (this.TenantGuid)
			obj.tenant_guid = this.TenantGuid;
	}

	public Read(obj: any, context: any): void {
		if (!obj.update_result)
			throw new Error();
		obj = obj.update_result;

		if (obj.guid !== undefined)
			this.Guid = obj.guid;

		if (obj.created !== undefined)
			this.Created = obj.created;

		if (obj.modified !== undefined)
			this.Modified = obj.modified;

		if (obj.subject !== undefined)
			this.Subject = obj.subject;

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.source_user_guid !== undefined)
			this.SourceUserGuid = obj.source_user_guid;

		if (obj.source_user_name !== undefined)
			this.SourceUserName = obj.source_user_name;

		if (obj.target_user_guid !== undefined)
			this.TargetUserGuid = obj.target_user_guid;

		if (obj.target_user_name !== undefined)
			this.TargetUserName = obj.target_user_name;

		if (obj.target_group_guid !== undefined)
			this.TargetGroupGuid = obj.target_group_guid;

		if (obj.target_group_name !== undefined)
			this.TargetGroupName = obj.target_group_name;

		if (obj.server_guid !== undefined)
			this.ServerGuid = obj.server_guid;

		if (obj.tenant_guid !== undefined)
			this.TenantGuid = obj.tenant_guid;
	}

}
